<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M3.12581 1.52031C2.92889 1.72987 2.8125 2.0551 2.8125 2.47626V17.5238C2.8125 17.9456 2.92889 18.2702 3.12581 18.4798L3.17589 18.5287L11.5596 10.0994V10V9.90069L3.17589 1.47064L3.12581 1.52031Z"
            fill="url(#paint0_linear_1518_20)"
        />
        <path
            d="M14.3537 12.9098L11.5596 10.0991V9.99981V9.90047L14.3544 7.09045L14.4173 7.12651L17.7284 9.018C18.6738 9.55823 18.6738 10.4421 17.7284 10.983L14.4173 12.8745L14.3537 12.9098Z"
            fill="url(#paint1_linear_1518_20)"
        />
        <g filter="url(#filter0_i_1518_20)">
            <path
                d="M14.4173 12.8737L11.5589 9.99969L3.12576 18.4794C3.43705 18.8114 3.95202 18.8523 4.53195 18.5216L14.4173 12.8737Z"
                fill="url(#paint2_linear_1518_20)"
            />
        </g>
        <path
            d="M14.4173 7.12591L4.53195 1.47866C3.95202 1.14731 3.43705 1.18882 3.12576 1.52085L11.5595 10.0006L14.4173 7.12591Z"
            fill="url(#paint3_linear_1518_20)"
        />
        <defs>
            <filter
                id="filter0_i_1518_20"
                x="3.12576"
                y="9.99969"
                width="11.2915"
                height="8.75031"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="-0.15" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_1518_20"
                />
            </filter>
            <linearGradient
                id="paint0_linear_1518_20"
                x1="10.8164"
                y1="2.31705"
                x2="-0.601739"
                y2="13.6733"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#00A0FF" />
                <stop offset="0.0066" stop-color="#00A1FF" />
                <stop offset="0.2601" stop-color="#00BEFF" />
                <stop offset="0.5122" stop-color="#00D2FF" />
                <stop offset="0.7604" stop-color="#00DFFF" />
                <stop offset="1" stop-color="#00E3FF" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_1518_20"
                x1="18.959"
                y1="9.99981"
                x2="2.58556"
                y2="9.99981"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#FFE000" />
                <stop offset="0.4087" stop-color="#FFBD00" />
                <stop offset="0.7754" stop-color="#FFA500" />
                <stop offset="1" stop-color="#FF9C00" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_1518_20"
                x1="12.865"
                y1="11.5604"
                x2="-2.6195"
                y2="26.961"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#FF3A44" />
                <stop offset="1" stop-color="#C31162" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_1518_20"
                x1="1.00186"
                y1="-3.48833"
                x2="7.9161"
                y2="3.38844"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#32A071" />
                <stop offset="0.0685" stop-color="#2DA771" />
                <stop offset="0.4762" stop-color="#15CF74" />
                <stop offset="0.8009" stop-color="#06E775" />
                <stop offset="1" stop-color="#00F076" />
            </linearGradient>
        </defs>
    </svg>
</template>
